function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardAltSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "dashboard-alt",
    "data-name": "Flat Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M2,8V4A2,2,0,0,1,4,2H20a2,2,0,0,1,2,2V8Zm14,2V22h4a2,2,0,0,0,2-2V10Z",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M14,10H2V20a2,2,0,0,0,2,2H14Z",
    style: {
      fill: "rgb(44, 169, 188)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardAltSvgrepoCom);
export default __webpack_public_path__ + "static/media/dashboard-alt-svgrepo-com.0bca8fd912ed727b992223c00a666533.svg";
export { ForwardRef as ReactComponent };